export const successColorScale = {
    0: "#000000",
    5: "#002D0F",
    10: "#004116",
    15: "#00541C",
    20: "#006923",
    25: "#007E2A",
    30: "#009331",
    35: "#375B29",
    40: "#1ABD50",
    50: "#2FDF6A",
    60: "#49FF86",
    70: "#7DFFA8",
    80: "#ABFFC7",
    90: "#D6FFE4",
    95: "#EAFFF1",
    98: "#F7FFFA",
    99: "#FBFFFC",
    100: "#FFFFFF",
};
